<template>
  <div class="contacts-wrapper">
    <div
      v-for="(contact, index) in contacts"
      :key="index"
      v-if="index < 3"
      :title="contact.title"
      :class="contact.contactClass"
      @click="onClickContact(contact.type)"
    >
      <b-img
        :src="isDark ? contact.imgDark : contact.img"
        :alt="contact.title"
      />
    </div>
    <div
      v-for="(contact, index) in contacts"
      :key="index"
      v-if="index > 2"
      @click="onClickContact(contact.type)"
      :title="contact.title"
      :class="contact.contactClass"
      @mouseover="contact.labelVisible = true"
      @mouseout="contact.labelVisible = false"
    >
      <b-img
        :src="isDark ? contact.imgDark : contact.img"
        :alt="contact.title"
      />
      <div
        v-if="contact.labelVisible"
        class="visible-label"
      >
        {{ contact.label }}
      </div>
    </div>
    <div
      :title="youtube.title"
      :class="youtube.contactClass"
      @click="onClickContact(youtube.type)"
    >
      <b-img
        :src="isDark ? youtube.imgDark : youtube.img"
        :alt="youtube.title"
      />
      <span
        v-if="youtube.label"
        class="label"
      >{{ youtube.label }}</span>
    </div>
    <div
      :title="faq.title"
      :class="faq.contactClass"
      @click="onClickContact(faq.type)"
    >
      <feather-icon
        :icon="faq.icon"
        size="21"
        class="mr-50"
      />
    </div>

    <b-sidebar
      bg-variant="white"
      shadow
      backdrop
      no-header
      right
      width="30%"
      v-model="sendMailSidebarIsVisible"
      @hidden="onHideSendMailSidebar"
    >
      <template>
        <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
          <h5 class="mb-0">{{ sendMailSidebarTitle }}</h5>
          <div class="d-flex align-items-center justify-content-center">
            <div title="Закрыть окно">
              <feather-icon
                class="ml-1 cursor-pointer"
                icon="XIcon"
                size="16"
                @click="hideSendMailSidebarSidebar"
              />
            </div>
          </div>
        </div>
        <div class="p-2">
          <b-overlay
            :show="overlayIsVisible"
            variant="transparent"
            opacity="0.9"
            rounded="sm"
            class="flex-column"
          >
            <form-renderer-component
              ref="sendMailSidebarForm"
              :fields="formFields"
              :form-data.sync="formData"
              :not-valid-fields="notValidFields"
              @updateFormData="onUpdateFormData"
            ></form-renderer-component>
            <hr>
            <div class="d-flex mt-1">
              <b-button
                class="mr-2 w-100"
                type="reset"
                variant="danger"
                @click="hideSendMailSidebarSidebar"
              >Закрыть</b-button>
              <b-button
                class="w-100"
                type="submit"
                variant="primary"
                @click="sendMail"
              >Отправить</b-button>
            </div>
          </b-overlay>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import { BDropdown, BDropdownItem, BNavItemDropdown, BImg, BSidebar, BButton, BOverlay } from 'bootstrap-vue'
import FormRendererComponent from '@/views/components/form/FormRendererComponent'
import { showFailedOperationToast, showSuccessOperationToast } from '@/composables/toast'
import youtubeSrc from '@/assets/images/contacts/youtube.svg'
import youtubeDarkThemeSrc from '@/assets/images/contacts/youtube-dark-theme.svg'
import telegramSrc from '@/assets/images/contacts/telegram.svg'
import telegramDarkThemeSrc from '@/assets/images/contacts/telegram-dark-theme.svg'
import viberSrc from '@/assets/images/contacts/viber.svg'
import viberDarkThemeSrc from '@/assets/images/contacts/viber-dark-theme.svg'
import bugSrc from '@/assets/images/contacts/bug.svg'
import bugDarkThemeSrc from '@/assets/images/contacts/bug-dark-theme.svg'
import ginSrc from '@/assets/images/contacts/gin.svg'
import ginDarkThemeSrc from '@/assets/images/contacts/gin-dark-theme.svg'
import { cloneDeep } from 'lodash'

export default {
  name: 'Contacts',
  components: {
    BDropdown, BDropdownItem, BNavItemDropdown, BImg, BSidebar, BButton, FormRendererComponent, BOverlay
  },
  data() {
    return {
      telegramAccount: 'ProfmanSupport_Bot',
      viberChat: 'profmansupport',
      phone: '375293123899',
      contacts: [
        {
          title: 'Пожелание по доработкам',
          label: null,
          type: 'feature-request',
          contactClass: 'contact gin padding-right',
          img: ginSrc,
          imgDark: ginDarkThemeSrc,
        },
        {
          title: 'Сообщение об ошибке',
          label: null,
          type: 'error',
          contactClass: 'contact bug padding-right',
          img: bugSrc,
          imgDark: bugDarkThemeSrc,
        },
        {
          title: 'Viber',
          label: '+375 (29) 312-38-99',
          type: 'viber',
          contactClass: 'contact viber padding-left',
          img: viberSrc,
          imgDark: viberDarkThemeSrc,
          labelVisible: false,
        },
        {
          title: 'Telegram',
          label: '@ProfmanSupport_Bot',
          type: 'telegram',
          contactClass: 'contact telegram padding-left padding-right',
          img: telegramSrc,
          imgDark: telegramDarkThemeSrc,
          labelVisible: false,
        },
      ],
      youtube: {
        title: 'Обучающий курс',
        label: 'Обучение',
        type: 'youtube',
        contactClass: 'contact youtube padding-left padding-right',
        img: youtubeSrc,
        imgDark: youtubeDarkThemeSrc,
      },
      faq: {
        title: 'Помощь',
        label: 'Помощь',
        type: 'faq',
        contactClass: 'contact faq padding-left',
        icon: 'HelpCircleIcon',
      },
      sendMailSidebarIsVisible: false,
      sendMailSidebarTitle: null,
      formFields: [
        {
          key: 'message',
          label: 'Текст обращения',
          placeholder: 'Введите текст обращения',
          type: 'textarea',
          required: true,
        },
        {
          key: 'files',
          type: 'dynamicFieldSet',
          fieldsSet: [
            {
              key: 'file',
              label: 'Файл',
              type: 'file',
              placeholder: 'Выберите файл',
              bColMdSize: 11
            },
          ],
        },
      ],
      formData: {
        message: null,
        type: null,
        files: null,
      },
      fileItem: {
        file: null
      },
      notValidFields: {},
      overlayIsVisible: false,
    }
  },
  computed: {
    isDark() {
      return this.$store.state.appConfig.layout.skin === 'dark'
    },
  },
  methods: {
    onClickContact(type) {
      if (type === 'telegram') {
        location.href = 'https://t.me/' + this.telegramAccount
      } else if (type === 'viber') {
        location.href = 'viber://pa?chatURI=' + this.viberChat
      } else if (type === 'support-contact-phone') {
        location.href = 'tel:%2B' + this.phone
      } else if (type === 'youtube') {
        window.open('https://www.youtube.com/playlist?list=PLFj0rjdUJ_-g1b0HVAD_qpX_tYdTYE2qu', '_blank')
      } else if (['support-request', 'feature-request', 'error'].includes(type)) {
        this.showSendMailSidebarSidebar(type)
      } else if (type === 'faq') {
        this.$router.push({name: 'apps-faq'})
      }
    },
    showSendMailSidebarSidebar(type) {
      if (type === 'feature-request') {
        this.sendMailSidebarTitle = 'Пожелание по доработкам'
      } else if (type === 'support-request') {
        this.sendMailSidebarTitle = 'Запрос в тех. поддержку'
      } else {
        this.sendMailSidebarTitle = 'Сообщение об ошибке'
      }
      this.formData.files = []
      this.formData.files.push(this.fileItem)
      this.formData.type = type
      this.formData = cloneDeep(this.formData)
      this.sendMailSidebarIsVisible = true
    },
    hideSendMailSidebarSidebar() {
      this.sendMailSidebarIsVisible = false
    },
    onHideSendMailSidebar() {
      Object.keys(this.formData).forEach(i => this.formData[i] = null)
      this.formData = cloneDeep(this.formData)
      this.notValidFields = {}
    },
    sendMail() {
      this.overlayIsVisible = true
      this.$store.dispatch('info/sendUserRequest', this.getFormData())
        .then(() => {
          showSuccessOperationToast('Обращение успешно отправлено')
          this.hideSendMailSidebarSidebar()
        })
        .catch(error => {
          this.processError(error)
          this.$refs.sendMailSidebarForm.$forceUpdate()
        })
        .finally(() => this.overlayIsVisible = false)
    },
    processError(err) {
      const errData = err.message.response.data
      if (!errData || !Array.isArray(errData['message'])) {
        showFailedOperationToast('Не удалось создать обращение')
      } else {
        Object.keys(errData).forEach(key => this.notValidFields[key] = errData[key][0])
      }
    },
    getFormData() {
      const data = new FormData()
      if (this.formData.message) {
        data.append('message', this.formData.message)
      }
      if (this.formData.files) {
        this.formData.files.map((item, index) => {
          if (item.file) {
            data.append('files[' + index + ']', item.file.target.files[0])
          }
        })
      }
      data.append('type', this.formData.type)
      return data
    },
    onUpdateFormData(data) {
      if (data && data.field && data.field.key) {
        this.removeErrorFromField(data.field.key)
      }
    },
    removeErrorFromField(fieldKey) {
      if (fieldKey in this.notValidFields) {
        delete this.notValidFields[fieldKey]
      }
    },
  }
}
</script>

<style lang='scss' scoped>

@import '@/core/scss/base/components';

.contacts-wrapper {
  padding: 10px 10px 10px 0;
  border-radius: 10px;
  display: flex;
  .contacts-dropdown {
    display: flex;
    align-items: center;
    .dropdown-toggle {
      &::after {
        float: right;
        left: 5px;
        color: $purple;
      }
      padding: 0 !important;
      margin: 0;
    }
    .dropdown-menu {
      li {
        &:hover {
          background: $purple;
          .dropdown-item-wrapper {
            color: $white;
          }
        }
      }
    }
    .dropdown-item-wrapper {
      display: flex;
      align-items: center;
      font-size: 12px;
      font-weight: 400;
    }
  }
  .contact {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    position: relative;
    &.padding-left {
      padding-left: 10px;
    }
    &.padding-right {
      padding-right: 10px;
    }
    &.bug {
      border-right: 1px solid $purple;
    }
    &.youtube {
      border-left: 1px solid $purple;
      .label {
        margin-left: 10px;
        font-family: 'Roboto Slab';
        font-size: 15px;
      }
    }
    &.faq {
      border-left: 1px solid $purple;
    }
    .visible-label {
      display: flex;
      position: absolute;
      white-space: nowrap;
      width: auto;
      background-color: $white;
      z-index: 1;
      left: 32px;
      top: -24px;
      padding: 4px 10px 4px 10px;
      box-shadow: 0 4px 21px rgba(0, 0, 0, 0.3);
      border-radius: 7px 7px 7px 0px;
      font-family: 'Roboto Slab';
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
    }
    img {
      width: 21px;
      height: 21px;
    }
    span {
      font-size: 12px;
    }
  }
}
.dark-layout {
  .contacts-wrapper {
    .contact {
      &.bug {
        border-right: 1px solid $theme-dark-label-color;
      }
      &.youtube {
        border-left: 1px solid $theme-dark-label-color;
      }
      &.faq {
        border-left: 1px solid $theme-dark-label-color;
      }
      .visible-label {
        background-color: #161D31;
        box-shadow: 0 0 14px 3px rgba(120, 108, 240, 0.25);
      }
    }
    .contacts-dropdown {
      .dropdown-item-wrapper {
        color: $theme-dark-label-color;
      }
      .dropdown-toggle {
        &::after {
          color: $theme-dark-label-color;
        }
      }
    }
  }
}

</style>
